import { forwardRef, Provider } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';

import { CcsRadioGroupComponent } from '../ccs-radio-group.component';

export const CCS_RADIO_GROUP_VALUE_ACCESSOR_PROVIDER: Provider = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => CcsRadioGroupComponent),
  multi: true,
};
